'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('../Backoffice/Button');

var _Button2 = _interopRequireDefault(_Button);

var _FooterLayout = require('./FooterLayout.scss');

var styles = _interopRequireWildcard(_FooterLayout);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FooterLayout = function FooterLayout(_ref) {
  var bottomChildren = _ref.bottomChildren,
      children = _ref.children,
      theme = _ref.theme,
      cancelText = _ref.cancelText,
      onCancel = _ref.onCancel,
      onOk = _ref.onOk,
      confirmText = _ref.confirmText,
      buttonsHeight = _ref.buttonsHeight,
      enableOk = _ref.enableOk,
      enableCancel = _ref.enableCancel,
      withTopPadding = _ref.withTopPadding;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)(styles.footer, _defineProperty({}, styles.withTopPadding, withTopPadding)),
        'data-hook': 'message-box-footer'
      },
      children,
      _react2.default.createElement(
        'div',
        { className: styles.footerbuttons },
        cancelText && _react2.default.createElement(_Button2.default, {
          disabled: !enableCancel,
          height: buttonsHeight,
          theme: 'empty' + theme,
          onClick: onCancel,
          dataHook: 'cancellation-button',
          children: cancelText
        }),
        _react2.default.createElement(_Button2.default, {
          disabled: !enableOk,
          height: buttonsHeight,
          theme: 'full' + theme,
          onClick: onOk,
          dataHook: 'confirmation-button',
          children: confirmText
        })
      )
    ),
    bottomChildren && _react2.default.createElement('div', {
      'data-hook': 'footer-layout-bottom-children',
      className: styles.bottomChildren,
      children: bottomChildren
    })
  );
};

FooterLayout.propTypes = {
  confirmText: _propTypes2.default.node,
  cancelText: _propTypes2.default.node,
  onCancel: _propTypes2.default.func,
  onOk: _propTypes2.default.func,
  enableOk: _propTypes2.default.bool,
  enableCancel: _propTypes2.default.bool,
  theme: _propTypes2.default.string,
  buttonsHeight: _propTypes2.default.string,
  children: _propTypes2.default.any,
  bottomChildren: _propTypes2.default.node,
  withTopPadding: _propTypes2.default.bool
};

FooterLayout.defaultProps = {
  theme: 'blue',
  buttonsHeight: 'small',
  enableOk: true,
  enableCancel: true,
  withTopPadding: false
};

exports.default = FooterLayout;